/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-23T10:16:01-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-17T15:09:56-07:00
*/



import React from 'react'
import { css, StyleSheet } from 'aphrodite/no-important';
import Avatar from '../../common/Avatar';
import { type, textColor, spacing } from '../../../style';
import TripDates from '../../blocks/TripDates';
// import { Link } from 'react-router';
// import {tsDate} from "../../../common";

const style = StyleSheet.create({
  msg: {
    textAlign: 'center',
    ...spacing.MARGIN_V_MD
  },

  msgTitle: {
    ...spacing.PADDING_V_XS,
    ...spacing.MARGIN_TOP_XS,
    ...type.BOLD,
    ...type.MD,
    ...textColor.DARK
  },

  tripDestination: {
    fontSize: 17,
    ...textColor.NORMAL,
    ...spacing.MARGIN_BOTTOM_SM
  },

  tripDatesContainer: {
    margin: '0 auto',
    maxWidth: 320
  },

  Avatar: {
    margin: '0 auto',
    width: '66px',
    height: '66px'
  }
})

const TripMsgItem = (props) => {
  return(
    <div className={css(style.msg)}>
      <div className={css(style.msgContainer, props.isSent && style.isSent)}>
        <div className={css(style.Avatar)}>
          {/* <Link to={`/~${}`}> */}
            <Avatar src={props.avatar} />
          {/* </Link> */}
        </div>
        <div className={css(style.msgTitle)}>
          {props.isSent ? 'You asked to join their trip to' : 'They asked to join your trip to'}
        </div>
        <div className={css(style.tripDestination)}>
          {props.tripData.city} {props.tripData.region}, {props.tripData.country}
        </div>
        <div className={css(style.tripDatesContainer)}>
          <TripDates leaveDt={props.tripData.leaving_dt.date} returnDt={props.tripData.returning_dt.date} />
        </div>
      </div>
      {/* <div className={css(style.msgFooter, props.isSent ? style.msgFooter_isSent : style.msgFooter_isReceived)}>{props.timeStamp}</div> */}
      {/* <pre style={{textAlign: 'left'}}><code>{JSON.stringify(props, null, 2)}</code></pre> */}
    </div>
  )};

TripMsgItem.propTypes = {
  userProfile: React.PropTypes.object,
  isSent: React.PropTypes.bool,
  msgText: React.PropTypes.string.isRequired,
  timeStamp: React.PropTypes.string.isRequired
};



export default TripMsgItem;



// WEBPACK FOOTER //
// ./src/components/pages/Mail/TripMsgItem.jsx